import $ from 'jquery';
import 'jquery.scrollto/jquery.scrollTo.min';
import 'jquery.localscroll/jquery.localScroll.min';
import { loadGoogleMapsAPI } from './lib/helpers';

// smooth scroll
$('.scroll-link').localScroll({ offset: -150 });

// google maps API key
const { googleMapsAPIKey } = window;
// Components
import createMapPopup from './components/map-popup';

window.initLocationsMap = () => {
  // Config
  const markers = [];
  const MapPopup = createMapPopup(google);
  const { velocityLocations: locations, themeDirectoryURI } = window;
  let zoom = 11;

  const map = new google.maps.Map(document.getElementById('locations-map'), {
    scrollwheel: false,
    disableDefaultUI: true,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP,
    },
    fullscreenControl: true,
    zoom,
  });

  // Reference https://www.raymondcamden.com/2014/08/09/Centering-a-Google-Map-on-America
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ address: '30.368954, -97.689047' }, (results, status) => {
    if (status == google.maps.GeocoderStatus.OK)
      map.setCenter(results[0].geometry.location);
    else alert(`Could not find location: ${location}`);
  });

  // setting custom map markers and pop ups for all locations
  const { atms, branches } = locations;

  setMapMarkers('atms', atms);
  setMapMarkers('branches', branches);

  /**
   * Creates custom map markers and pop ups for Google maps
   *
   * @param {string} type Location type
   * @param {object} locations Location object
   */
  function setMapMarkers(type, locations) {
    locations.forEach((location, index) => {
      const { map: address } = location;

      if (!address.lat || !address.lng) return false;

      const anchor =
        type === 'branches'
          ? new google.maps.Point(0, 40)
          : new google.maps.Point(-9, 50);
      const zIndex = type === 'branches' ? 200 : 100;

      const position = new google.maps.LatLng(address.lat, address.lng);

      const marker = new google.maps.Marker({
        position: position,
        icon: {
          url: `${themeDirectoryURI}/images/${type}-marker.png`,
          scaledSize: new google.maps.Size(30, 40),
          size: new google.maps.Size(30, 40),
          origin: new google.maps.Point(0, 0),
          anchor,
        },
        map,
      });

      const popup = new MapPopup(
        position,
        document.getElementById(`map-popup-${type}-${index}`)
      );

      popup.setMap(map);
      marker.setZIndex(zIndex);

      marker.addListener('click', e => {
        popup.toggle();
      });

      markers.push(marker);
    });
  }
};

if (googleMapsAPIKey) loadGoogleMapsAPI('initLocationsMap');
